module.exports = __webpack_public_path__ + "static/media/design3.5796b0f8.png";